function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  style: {
    marginLeft: "20px"
  },
  fill: "none",
  viewBox: "0 0 385 280"
}, props), React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M0 75c0-5.523 4.477-10 10-10h404c5.523 0 10 4.477 10 10v130c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10V75z",
  fill: "#fff"
})), React.createElement("rect", {
  width: "325",
  height: "20",
  rx: "10",
  transform: "matrix(1 0 0 -1 30 165)",
  fill: "#F2F2F2"
}), React.createElement("rect", {
  width: "269.286",
  height: "20",
  rx: "10",
  transform: "matrix(1 0 0 -1 30 165)",
  fill: "#FFC43E"
}), React.createElement("rect", {
  width: "130",
  height: "15",
  rx: "2",
  transform: "matrix(1 0 0 -1 30 130)",
  fill: "#F2F2F2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M353.019 124.017L331.01 86.002l-22.009 38.015h44.018zm-24.01-6.002v-4.002h4.002v4.002h-4.002zm0-8.004h4.002v-8.003h-4.002v8.003z",
  fill: "#FFC43E"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h385v280H0z"
})), React.createElement("filter", {
  id: "filter0_d",
  x: "-10",
  y: "60",
  width: "444",
  height: "170",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));